import { render, staticRenderFns } from "./company-edit.vue?vue&type=template&id=b450afd6&scoped=true"
import script from "./company-edit.vue?vue&type=script&lang=js"
export * from "./company-edit.vue?vue&type=script&lang=js"
import style0 from "./company-edit.vue?vue&type=style&index=0&id=b450afd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450afd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b450afd6')) {
      api.createRecord('b450afd6', component.options)
    } else {
      api.reload('b450afd6', component.options)
    }
    module.hot.accept("./company-edit.vue?vue&type=template&id=b450afd6&scoped=true", function () {
      api.rerender('b450afd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/companies/components/company-edit.vue"
export default component.exports